import { AppError } from '../app-error';

export abstract class ApiError extends AppError {
  protected constructor(key: string, message: string) {
    super(key, message);
  }
}
